// packages/programSpecializations/src/index.ts
import _chunk from "lodash/chunk";
import _omit from "lodash/omit";
import {userHasAnyAllowedRole} from "@shared/permissions/validators";
function programSpecializationsUtils(fields, user) {
  const BASE_TEMPLATE = [
    [
      {id: "code", type: "question"},
      {id: "tags", type: "question"}
    ],
    [
      {id: "name", type: "question"},
      {id: "longName", type: "question"}
    ],
    [
      {id: "type", type: "question"},
      {id: "status", type: "question"}
    ],
    [
      {id: "effectiveStartDate", type: "question"},
      {id: "effectiveEndDate", type: "question"}
    ],
    [
      {id: "cipCode", type: "question"},
      {id: "hegisCode", type: "question"}
    ],
    [
      {id: "firstTermValid", type: "question"},
      {id: "lastAdmitTerm", type: "question"}
    ],
    [
      {id: "defaultOfRequirementTerm", type: "question"},
      {id: "lastProspectDate", type: "question"}
    ],
    [
      {id: "transcriptLevel", type: "question"},
      {id: "evaluateSubplan", type: "question"}
    ],
    [
      {id: "transcriptDescription", type: "question"},
      {id: "printOnTranscript", type: "question"}
    ],
    [
      {id: "diplomaDescription", type: "question"},
      {id: "printOnDiploma", type: "question"}
    ]
  ];
  function getTemplate() {
    const baseTemplateQuestionIds = BASE_TEMPLATE.flatMap((row) => row.map((el) => el.id));
    const customFieldsIds = Object.keys(_omit(fields, baseTemplateQuestionIds));
    const customQuestionsTemplate = _chunk(customFieldsIds.map((id) => ({id, type: "question"})), 2);
    const visibleFields = [...BASE_TEMPLATE, ...customQuestionsTemplate].map((row) => row.filter(isQuestionVisible));
    return visibleFields.filter((row) => row.length);
  }
  function getTemplateWithHiddenFields() {
    const baseTemplateQuestionIds = BASE_TEMPLATE.flatMap((row) => row.map((el) => el.id));
    const customFieldsIds = Object.keys(_omit(fields, baseTemplateQuestionIds));
    const customQuestionsTemplate = _chunk(customFieldsIds.map((id) => ({id, type: "question"})), 2);
    return [...BASE_TEMPLATE, ...customQuestionsTemplate];
  }
  function isQuestionVisible(question) {
    if (!question || !fields || !fields[question.id])
      return false;
    const fieldDefinition = fields[question.id] || {id: ""};
    return userHasAnyAllowedRole(user, null, fieldDefinition["rolesAllowedToSee"]);
  }
  return {
    template: getTemplate(),
    templateWithHiddenFields: getTemplateWithHiddenFields()
  };
}
export {
  programSpecializationsUtils
};
